module.exports = __webpack_public_path__ + "img/robed.6ca3c87a.png";